(function() { window.GUID_5a51746c_61c8_4ea4_85be_d41b37d6244b = { getGuid: function() { return "5a51746c-61c8-4ea4-85be-d41b37d6244b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventRowContainer extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, '.event-row .button');
                this.$control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.on('click.' + me.controlId, '.event-row .button', function (e) {
                    let $this = $(this);
                });
            }
        }
        Controls.EventRowContainer = EventRowContainer;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-row-container.js.map
